export const loadDocumentsSuccessAction = (state, documents) => {
  return {
    ...state,
    documents,
    isLoading: false
  }
}
